import Vue from 'vue';
import Router from 'vue-router';
import App from './App';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:id',
      name: 'home',
      component: App,
    },
    {
      path: '/:id/totem',
      name: 'totem',
      component: App,
    },
    {
      path: '/:id/natal-luz',
      name: 'natal-luz',
      component: App,
    },
    {
      path: '/order/:hash',
      name: 'commissioner',
      component: App,
    }
  ],
});
